<template>
  <div class="album_detail_wrap">
    <div class="album_detail">
      <page-header class="not_main"></page-header>
      <div class="album_detail_content">

        <image-component :infoType="`albumBanner`"></image-component>

        <div class="album_detail_content_box">
          <board-detail-component :boardType="`albumDetail`" :boardKey="boardKey"></board-detail-component>
<!--          <div class="album_detail_content_box_bottom">-->
<!--            <button class="album_detail_content_box_bottom_backBtn" @click="backEvent()">목록</button>-->
<!--          </div>-->
        </div>
      </div>
        <page-footer class="not_main"></page-footer>
      </div>
    </div>
</template>

<script>
import BoardDetailComponent from "@/components/board/BoardDetailComponent";
import ImageComponent from "@/components/information/ImageComponent";
export default {
  name: "AlbumDetail",
  mixins: [],
  components: {BoardDetailComponent,ImageComponent},
  inject: [],
  provide() {
    return {}
  },
  props: {},
  data() {
    return {
      boardKey: ''
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.getBoardKey()
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {
  },
  computed: {},
  methods: {
    getBoardKey() {
      this.boardKey = this.$route.params.wr_id
    },
    backEvent() {
      this.$router.back();
    }
  },
  watch: {},
}
</script>

<style scoped>

</style>